import { render, staticRenderFns } from "./EventLayout.vue?vue&type=template&id=307020fc&scoped=true&"
import script from "./EventLayout.vue?vue&type=script&lang=js&"
export * from "./EventLayout.vue?vue&type=script&lang=js&"
import style0 from "./EventLayout.vue?vue&type=style&index=0&id=307020fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307020fc",
  null
  
)

export default component.exports